import { Header, Space, Spacer, TextLoader } from '@procurify/ui'

import { AuditLogRecordStyled } from './styles/AuditLogRecordStyled'

export const AuditLogRecordLoader = () => {
  return (
    <AuditLogRecordStyled status='Cancelled'>
      <Space size='xsmall'>
        <Header as='h5'>
          <TextLoader width={150} />
        </Header>

        <TextLoader width={300} />
      </Space>

      <Spacer />

      <Space size='small'>
        <TextLoader width={100} />
        <Space direction='horizontal'>
          <TextLoader width={125} />
          <TextLoader width={125} />
        </Space>
      </Space>
    </AuditLogRecordStyled>
  )
}
